import { jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { useButtonRole } from '@flex-design-system/fx-utils/hooks';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getColor } from '../../../utils/colors.mjs';
import { PrimitiveAnchor } from '../../anchor/PrimitiveAnchor.mjs';
import { textButton, textButtonFocusVisible, textButtonColor } from './textButton.vanilla.mjs';

const TEXT_BUTTON_ACCENT_COLOR = "blue";
const TextButtonImpl = forwardRef(
  ({
    color = "blue",
    className: classNameFromProps,
    disabled,
    elementType,
    style: styleFromProps,
    ...props
  }, forwardedRef) => {
    const isGradientButtonColor = isPresetGradientColor(color);
    const className = classNames(
      textButton({
        accentColor: color === TEXT_BUTTON_ACCENT_COLOR,
        disabled,
        gradientText: isGradientButtonColor
      }),
      !isGradientButtonColor && textButtonFocusVisible,
      classNameFromProps
    );
    const style = Object.assign(
      {},
      assignInlineVars({
        [textButtonColor]: getColor(color)
      }),
      styleFromProps
    );
    const { handler, htmlProps } = useButtonRole({
      disabled,
      checkForDefaultPrevented: true
    });
    const handleClick = handler.click(
      (event) => props.onClick?.(event)
    );
    const handleKeyDown = handler.keydown(
      (event) => props.onKeyDown?.(event)
    );
    return /* @__PURE__ */ jsx(
      Primitive.span,
      {
        asChild: true,
        className,
        style,
        ref: forwardedRef,
        children: elementType === "anchor" ? /* @__PURE__ */ jsx(PrimitiveAnchor, { ...props, disabled }) : /* @__PURE__ */ jsx(
          Primitive.span,
          {
            ...props,
            ...htmlProps,
            tabIndex: disabled === true ? void 0 : 0,
            onClick: handleClick,
            onKeyDown: handleKeyDown
          }
        )
      }
    );
  }
);
const TextButton = styled(TextButtonImpl);
TextButton.displayName = "TextButton";

export { TextButton };
//# sourceMappingURL=TextButton.mjs.map
